import { surfaceV100Background } from "@Components/common/byb-ds/buttons/styled-components";
import MuiTextField from "@Components/generic/mui-text-field";
import { styled, TextField, TextFieldProps } from "@mui/material";

// Common styles shared between both components
const commonStyles = (theme: any, multiline?: boolean) => ({
  "& .MuiInputLabel-root": {
    position: "relative",
    transform: "none",
    color: theme.palette.dsBase.v200,
    width: "min-content",
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
    opacity: 0.6,
    ...theme.typography.textBase500,
  },
  "& .MuiFilledInput-root": {
    overflow: "hidden",
    color: theme.palette.dsBase.v200,
    borderRadius: 16,
    ...surfaceV100Background(theme),
  },
  "& .MuiFilledInput-input": {
    padding: theme.spacing(2.5),
    ...theme.typography.text1xl500,
    "&::placeholder": {
      opacity: 0.4,
    },
    "&:focus": {
      backgroundColor: "transparent",
    },
  },
  "& .MuiSelect-iconFilled": {
    color: theme.palette.dsNeutral.v300,
    right: theme.spacing(2.5),
  },
  ...(multiline && {
    "& .MuiInputBase-inputMultiline": {
      padding: theme.spacing(3, 1.5),
    },
  }),
});

// Base component with MuiTextField functionality
export const StyledTextFieldAlt = styled((props: TextFieldProps) => (
  <MuiTextField
    {...props}
    variant="filled"
    InputProps={{
      disableUnderline: true,
      ...props.InputProps,
    }}
    InputLabelProps={{ shrink: true }}
  />
))(({ theme, multiline }) => commonStyles(theme, multiline));

// Lightweight version without MuiTextField functionality
export const StyledSelect = styled((props: TextFieldProps) => (
  <TextField
    {...props}
    variant="filled"
    InputProps={{
      disableUnderline: true,
      ...props.InputProps,
    }}
    InputLabelProps={{ shrink: true }}
    select
  />
))(({ theme, multiline }) => commonStyles(theme, multiline));
